module.exports = __webpack_public_path__ + "img/flavour-smoke-logo.37985ed2.png";